import React from 'react';
import { Admin, Resource } from 'react-admin';
// eslint-disable-next-line import/no-unresolved
import spanishMessages from '@blackbox-vision/ra-language-spanish';
import englishMessages from 'ra-language-english';
import polyglotI18nProvider from 'ra-i18n-polyglot';

// Components
import CustomTheme from '../theme/CustomTheme';
import CustomLayout from '../layout/CustomLayout';
import CustomLogin from '../login/CustomLogin';
import ClientsList from '../../views/Clients';
import CoursesList from '../../views/Courses';
import UnitsList from '../../views/Units';
import LicensesList from '../../views/Licenses';
import UserList from '../../views/Users';
import ScormsList from '../../views/Scorms';
import StudentsList from '../../views/Students';

import authProvider from '../../providers/authProvider';
import customDataProvider from '../../providers/customDataProvider';
import * as domainMessages from '../../utils/i18n';
import routes from '../../routes';

const messages = {
  es: { ...spanishMessages, ...domainMessages.es },
  en: { ...englishMessages, ...domainMessages.en },
};

// Language
const i18nProvider = polyglotI18nProvider((locale) => messages[locale], 'es');

const DistantScorm = () => (
  <Admin
    authProvider={authProvider}
    dataProvider={customDataProvider}
    customRoutes={routes}
    i18nProvider={i18nProvider}
    layout={CustomLayout}
    theme={CustomTheme}
    loginPage={CustomLogin}
  >
    {(permissions) => [
      permissions && <Resource name="clients" {...ClientsList} />,
      permissions && <Resource name="courses" {...CoursesList} />,
      permissions && <Resource name="units" {...UnitsList} />,
      permissions && <Resource name="licenses" {...LicensesList} />,
      permissions && <Resource name="users" {...UserList} />,
      permissions && <Resource name="scorms" {...ScormsList} />,
      permissions && <Resource name="students" {...StudentsList} />,
    ]}
  </Admin>
);

export default DistantScorm;
